import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase URL e Anon Key são necessários');
  throw new Error('Supabase URL e Anon Key são necessários');
}

// Configurações otimizadas para melhor performance e confiabilidade
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Reduzir timeout para detecção mais rápida de problemas
    flowType: 'pkce',
  },
  global: {
    headers: {
      'x-client-info': 'union-connect-evolve',
    },
  },
  db: {
    schema: 'public',
  },
  // Configurações de fetch otimizadas
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});
